var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { visible: _vm.showModal, size: "50%" },
          on: {
            "update:visible": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-start",
                style: { gap: "8px" }
              },
              [
                _c(
                  "el-tag",
                  { staticClass: "rounded-circle", attrs: { type: "success" } },
                  [_c("i", { staticClass: "el-icon-notebook-2" })]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v("Consulta SPC")]),
                  _vm._v(" "),
                  _vm.spcConsulta && _vm.spcConsulta.protocolo
                    ? _c("span", { staticClass: "text-muted" }, [
                        _vm._v("#" + _vm._s(_vm.spcConsulta.protocolo.numero))
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.spcConsulta
            ? _c(
                "CardBase",
                [
                  _vm.getConsumer["consumidor-pessoa-juridica"]
                    ? _c(
                        "el-descriptions",
                        {
                          attrs: {
                            title: "Dados do consumidor (PJ)",
                            column: 4,
                            size: "small",
                            border: true
                          }
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Razão Social" } },
                            [
                              _vm.getConsumer["consumidor-pessoa-juridica"][
                                "razao-social"
                              ]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-juridica"
                                          ]["razao-social"] || "Não informado"
                                        ) +
                                        "\n                    \n                "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "CNPJ" } },
                            [
                              _vm.getConsumer["consumidor-pessoa-juridica"][
                                "cnpj"
                              ]["numero"]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-juridica"
                                          ]["cnpj"]["numero"] || "Não informado"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Situação CNPJ" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getConsumer[
                                      "consumidor-pessoa-juridica"
                                    ]["situacao-cnpj"]
                                      ? _vm.getConsumer[
                                          "consumidor-pessoa-juridica"
                                        ]["situacao-cnpj"]["descricao-situacao"]
                                      : "Não informado"
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Data Fundação" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getConsumer[
                                      "consumidor-pessoa-juridica"
                                    ]["data-fundacao"]
                                      ? _vm.formatDate(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-juridica"
                                          ]["data-fundacao"],
                                          true
                                        )
                                      : "Não informado"
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Endereço" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getFormattedAddress(
                                      _vm.getConsumer[
                                        "consumidor-pessoa-juridica"
                                      ]["endereco"]
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getConsumer["consumidor-pessoa-fisica"]
                    ? _c(
                        "el-descriptions",
                        {
                          attrs: {
                            title: "Dados do consumidor (PF)",
                            column: 4,
                            size: "small",
                            border: true
                          }
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Nome" } },
                            [
                              _vm.getConsumer["consumidor-pessoa-fisica"][
                                "nome"
                              ]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-fisica"
                                          ]["nome"] || "Não informado"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "CPF" } },
                            [
                              _vm.getConsumer["consumidor-pessoa-fisica"][
                                "cpf"
                              ]["numero"]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-fisica"
                                          ]["cpf"]["numero"]
                                            ? _vm.formatCPF(
                                                _vm.getConsumer[
                                                  "consumidor-pessoa-fisica"
                                                ]["cpf"]["numero"]
                                              )
                                            : "Não informado"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Situação CPF" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getConsumer["consumidor-pessoa-fisica"][
                                      "situacao-cpf"
                                    ]
                                      ? _vm.getConsumer[
                                          "consumidor-pessoa-fisica"
                                        ]["situacao-cpf"]["descricao-situacao"]
                                      : "Não informado"
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Data de Nascimento" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getConsumer["consumidor-pessoa-fisica"][
                                      "data-nascimento"
                                    ]
                                      ? _vm.formatDate(
                                          _vm.getConsumer[
                                            "consumidor-pessoa-fisica"
                                          ]["data-nascimento"],
                                          true
                                        )
                                      : "Não informado"
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { span: 4, label: "Endereço" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getFormattedAddress(
                                      _vm.getConsumer[
                                        "consumidor-pessoa-fisica"
                                      ]["endereco"]
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-descriptions",
                    {
                      staticClass: "my-3",
                      attrs: {
                        title: "Resumo da Consulta",
                        column: 4,
                        size: "small",
                        border: true
                      }
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { span: 4, label: "Restrição" } },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "rounded-pill",
                              attrs: {
                                type: !_vm.spcConsulta.restricao
                                  ? "danger"
                                  : "success",
                                size: "small"
                              }
                            },
                            [
                              !_vm.spcConsulta.restricao
                                ? _c("span", [_vm._v("Sim")])
                                : _c("span", [_vm._v("Não")])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { span: 4, label: "Consultas (90 dias)" } },
                        [
                          _vm.getConsult
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getConsult.resumo["quantidade-total"]
                                  )
                                )
                              ])
                            : _c("span", [_vm._v("0")])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeResume,
                        callback: function($$v) {
                          _vm.activeResume = $$v
                        },
                        expression: "activeResume"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { name: "1" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-grow-1 d-flex align-items-center justify-content-between pr-3"
                              },
                              [
                                _c("span", [_vm._v("SPC")]),
                                _vm._v(" "),
                                _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.getSPCResumTotal) +
                                      "\n                        "
                                  )
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.getSPCResumTotal > 0
                            ? _c(
                                "div",
                                [
                                  _vm.getSPCDetails
                                    ? _c(
                                        "CardBase",
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              directives: [
                                                {
                                                  name: "loading",
                                                  rawName: "v-loading",
                                                  value: _vm.isLoading,
                                                  expression: "isLoading"
                                                }
                                              ],
                                              staticClass: "rounded",
                                              attrs: {
                                                data: _vm.getSPCDetails,
                                                align: "center",
                                                border: ""
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Nome",
                                                  "min-width": "90",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          scope.row[
                                                            "nome-associado"
                                                          ]
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row[
                                                                      "nome-associado"
                                                                    ]
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "Nome da empresa indisponível"
                                                                )
                                                              ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3425672026
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "UF",
                                                  width: "60",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  "cidade-associado"
                                                                ]["estado"][
                                                                  "sigla-uf"
                                                                ]
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1650118949
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Cidade",
                                                  width: "160",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  "cidade-associado"
                                                                ]["nome"]
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  889101516
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Valor",
                                                  width: "160",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          scope.row["valor"]
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatCurrency(
                                                                      scope.row[
                                                                        "valor"
                                                                      ]
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "Valor indisponível"
                                                                )
                                                              ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  136257352
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c("el-empty", {
                                attrs: {
                                  description:
                                    "Nenhum detalhe sobre SPC disponível."
                                }
                              })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { name: "2" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-grow-1 d-flex align-items-center justify-content-between pr-3"
                              },
                              [
                                _c("span", [_vm._v("Protestos")]),
                                _vm._v(" "),
                                _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.getProtestResumTotal) +
                                      "\n                        "
                                  )
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.getProtestResumTotal > 0
                            ? _c(
                                "div",
                                [
                                  _vm.getProtestDetails
                                    ? _c(
                                        "CardBase",
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              directives: [
                                                {
                                                  name: "loading",
                                                  rawName: "v-loading",
                                                  value: _vm.isLoading,
                                                  expression: "isLoading"
                                                }
                                              ],
                                              staticClass: "rounded",
                                              attrs: {
                                                data: _vm.getProtestDetails,
                                                align: "center",
                                                border: ""
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Catorio",
                                                  "min-width": "90",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          scope.row["cartorio"][
                                                            "nome"
                                                          ]
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row[
                                                                      "cartorio"
                                                                    ]["nome"]
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "Cartorio não informado"
                                                                )
                                                              ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1985946743
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "UF",
                                                  width: "60",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  "cartorio"
                                                                ]["cidade"][
                                                                  "estado"
                                                                ]["sigla-uf"]
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1136749087
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Cidade",
                                                  width: "160",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  "cartorio"
                                                                ]["cidade"][
                                                                  "nome"
                                                                ]
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3132374710
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "Valor",
                                                  width: "160",
                                                  align: "left"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          scope.row["valor"]
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatCurrency(
                                                                      scope.row[
                                                                        "valor"
                                                                      ]
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "Valor indisponível"
                                                                )
                                                              ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  136257352
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c("el-empty", {
                                attrs: {
                                  description:
                                    "Nenhum detalhe sobre protesto disponível."
                                }
                              })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3135e34e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3135e34e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/spc/SPCShowModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3135e34e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/spc/SPCShowModal.vue
// module chunks = 2